import gql from 'graphql-tag';

export const CHECK_SYMON_CONNECTIVITY = gql`
  query CheckSymonConnectivity($input: checkSymonConnectivityInput) {
    checkSymonConnectivity(input: $input)
  }
`;
